export const presentation = [
  {
    path: '/presentation',
    component: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/Presentation'),
    children: [
      {
        path: 'create',
        components: {
          body: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBody'),
          bar: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBar'),
        },
      },
      {
        path: ':id/edit',
        components: {
          body: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBody'),
          bar: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationEditBar'),
        },
      },
      {
        path: ':id/persons',
        components: {
          body: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationPersonsBody'),
          bar: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationPersonsBar'),
        }
      },
      {
        path: ':id/participations',
        components: {
          body: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationParticipationsBody'),
          bar: () => import(/* webpackChunkName: "presentation" */ '@/views/presentation/components/PresentationParticipationsBar'),
        }
      },
    ]
  },
]
